export const Config = {
  API_URL: `${process.env.NEXT_PUBLIC_API_URL}/api/v1`,
  API_KEY: process.env.NEXT_PUBLIC_API_KEY,
  WEB_URL: process.env.NEXT_PUBLIC_WEB_URL,
  FRESHCHAT_TOKEN: process.env.NEXT_PUBLIC_FRESHCHAT_TOKEN,
  FRESHCHAT_ID: process.env.NEXT_PUBLIC_FRESHCHAT_ID
};
